import React, { useEffect, useState } from "react";
import { DefaultPopup } from "../../modal";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { hocSinhApi } from "../../../api/hocSinhApi";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { showNotify } from "../../../helpers/toast";
import { TagBox } from "devextreme-react/tag-box";
import { Button } from "../../buttons";
import { TextArea } from "devextreme-react";

type SendBienLaiModalProps = {
    onClose: () => void,
    sf_mucphaithu: sf_mucphaithu,
    ts_hocsinh_id: number
}

const SendBienLaiModal: React.FC<SendBienLaiModalProps> = (props) => {
    const [suggest_emails, set_suggest_emails] = useState<{ email: string }[]>([]);
    const [email_to_send_when_finish, set_email_to_send_when_finish] = useState<string[]>([]);
    const [isSaving, SetIsSaving] = useState<boolean>(false);
    const [emailContent, setEmailContent] = useState<string>('Đang tải nội dung email...');

    useEffect(() => {
        const handleReloadEmail = async () => {
            const res = await hocSinhApi.selectParentEmail(props.ts_hocsinh_id);
            if (res.is_success) {
                set_suggest_emails(res.data);
                // Mặc định chọn tất cả email khi load xong
                const allEmails = res.data.map((item: any) => item.email);
                set_email_to_send_when_finish(allEmails);
            }
        };
        handleReloadEmail();
    }, [props.ts_hocsinh_id]);

    useEffect(() => {
        const loadEmailContent = async () => {
            try {
                const res = await bienLaiThuApi.get_email_content(props.sf_mucphaithu.id);
                if (res.is_success && res.data) {
                    setEmailContent(res.data);
                } else {
                    setEmailContent('Không thể tải nội dung email');
                }
            } catch (error) {
                console.error('Error loading email content:', error);
                setEmailContent('Không thể tải nội dung email');
            }
        };
        loadEmailContent();
    }, [props.sf_mucphaithu.id]);

    const hanldeSubmit = async () => {
        SetIsSaving(true);
        const combinedEmails = email_to_send_when_finish.join(",");

        const res = await bienLaiThuApi.send_bienlai({
            sf_mucphaithu_id: props.sf_mucphaithu.id,
            email: combinedEmails,
            bcc_email: ""
        });

        if (res.is_success) {
            showNotify({ message: "Đã gửi email biên lai thu phí", type: "success" });
            props.onClose();
        } else {
            showNotify({ message: "Không gửi được biên lai", type: "warning" });
        }

        SetIsSaving(false);
    }

    return (
        <DefaultPopup title="Gửi thư xác nhận đến PHHS" width={'xlarge'} onClose={props.onClose}>
            <div className="pop-up-form">
                <div className="col-md-12 padding-top-1em">
                    <h4>Chọn Email từ danh sách bên dưới hoặc điền email mới để gửi</h4>
                    <div className="margin-bottom-5">Gửi tới Email:</div>
                    <br />
                    <TagBox
                        items={suggest_emails}
                        showSelectionControls={true}
                        searchEnabled
                        displayExpr={'email'}
                        valueExpr={'email'}
                        value={email_to_send_when_finish}
                        multiline={true}
                        stylingMode="outlined"
                        width={'100%'}
                        showClearButton={true}
                        height={'auto'}
                        applyValueMode="useButtons"
                        acceptCustomValue={true}
                        onValueChanged={(e: any) => {
                            set_email_to_send_when_finish(e.value || []);
                        }}
                        onCustomItemCreating={(e: any) => {
                            const newItem = e.text.trim();
                            const lowerCasedNewValue = newItem.toLowerCase();
                            if (newItem && !suggest_emails.some((item: any) => item.email.toLowerCase() === lowerCasedNewValue)) {
                                const newEmail = { email: newItem };
                                set_suggest_emails([...suggest_emails, newEmail]);
                                e.customItem = new Promise(resolve => {
                                    resolve(newEmail);
                                });
                                set_email_to_send_when_finish([...email_to_send_when_finish, newEmail.email]);
                            }
                        }}
                    />
                    <br />
                    <div className="margin-bottom-5">Nội dung email:</div>
                    <br />
                    <TextArea
                        value={emailContent}
                        readOnly={true}
                        stylingMode="outlined"
                        width={'100%'}
                        height={200}
                        showClearButton={false}
                    />
                </div>
            </div>
            <div className="pop-up-actions">
                <Button type="normal" text="Đóng" icon="fa fa-times" onClick={props.onClose} />{' '}
                <Button isLoading={isSaving} type="normal" icon="fas fa-check-square"
                    text="Gửi thư xác nhận" onClick={hanldeSubmit} />{' '}
            </div>
        </DefaultPopup>
    );
}

export default SendBienLaiModal;
